import React, {useEffect, useState} from "react";
import ReviewCard from "../card/ReviewCard";
import { api1 } from "../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../services/apiEndpoints";
import moment from "moment";
import { useSelector } from "react-redux";

const ReviewListsComponent = ({ mentorId: propMentorId }) => {
  const loggedInUserId = useSelector((state) => state.auth.id);
  const userType = useSelector((state) => state.auth.type);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  const mentorId = propMentorId || (userType === "mentor" ? loggedInUserId : null);

  const fetchAllMentorReviews = async () => {
    if (!mentorId) return;
    
    setLoading(true);
    try {
      const reviewRes = await api1.get(
        `${API_ENDPOINTS.GET_MENTOR_REVIEW}/${mentorId}`,
        {
          meta: { showToast: false },
        }
      );
      setReviews(reviewRes.data.data || []);
    } catch (error) {
      console.error(`Failed to fetch reviews for mentor ${mentorId}`, error);
      setReviews([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllMentorReviews();
  }, [mentorId]); 

  if (loading) {
    return <div className="text-center p-4">Loading reviews...</div>;
  }

  const handleApprovalUpdate = (reviewId, newStatus) => {
    setReviews(prevReviews => 
      prevReviews.map(review => 
        review._id === reviewId 
          ? { ...review, mentorApproval: newStatus }
          : review
      )
    );
  };

  return (
    <div className="mx-auto mt-10 space-y-4 bg-white p-4 md:p-4 rounded-lg">
      {reviews.length > 0 ? (
        reviews.map((review) => (
          <ReviewCard
            key={review._id}
            reviewId={review._id}
            name={review.menteeId
                ? `${review.menteeId.firstName || review.menteeId.profile?.firstName || ''} ${review.menteeId.lastName || review.menteeId.profile?.lastName || ''}`.trim()
                : "Anonymous"
            }            
            avatar={
              review.menteeId?.profile?.profilePhoto
                ? review.menteeId.profile.profilePhoto
                : "https://www.pngitem.com/pimgs/m/146-1468479_my-profile-icon-blank-profile-picture-circle-hd.png"
            }
            date={moment(review.createdAt).fromNow(true)}
            rating={review.rating}
            comment={review.review}
            mentorApproval={review.mentorApproval}
            onApprovalUpdate={handleApprovalUpdate}
          />
        ))
      ) : (
        <div className="text-center text-gray-500">No reviews yet</div>
      )}
    </div>
  );
};

export default ReviewListsComponent;
